import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPackage = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.112 8.712v6.558c0 .869-.464 1.672-1.216 2.106l-5.68 3.279a2.43 2.43 0 0 1-2.433 0l-5.68-3.279a2.43 2.43 0 0 1-1.215-2.106V8.712c0-.87.464-1.673 1.216-2.108l5.68-3.279a2.44 2.44 0 0 1 2.432 0l5.68 3.28a2.43 2.43 0 0 1 1.216 2.107"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.426 5.046 7.772 4.496v2.74"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4.225 7.465 7.772 4.496 7.77-4.496M12.002 21v-9.046"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPackage);
export default ForwardRef;
